// @flow
export let GOT_NUM_SYNC_ITEMS = "GOT_NUM_SYNC_ITEMS";

export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const ERRORED_AJAX_CALL = 'ERRORED_AJAX_CALL';

export const SET_CLIENT_ID = "SET_CLIENT_ID";
export const SET_CLIENT_INFO = "SET_CLIENT_INFO";

export const GOT_LOGIN_UPDATE = "GOT_LOGIN_UPDATE";
export const GOT_LOGOUT_UPDATE = "GOT_LOGOUT_UPDATE";
export const GOT_FIRMWARE_ERROR = "GOT_FIRMWARE_ERROR";

export const GOT_SERVER_INFO = "GOT_SERVER_INFO";

export const GET_MAGINFO_SUCCESS = "GET_MAGINFO_SUCCESS";
export const GOT_MARK_SECTION_FULL ="GOT_MARK_SECTION_FULL";
export const CLEAR_MAG_AND_SAMPLES = "CLEAR_MAG_AND_SAMPLES";

export const GOT_CURRENT_PROFILESET = "GOT_CURRENT_PROFILESET";
export const GOT_MAG_TYPES_LIST="GOT_MAG_TYPES_LIST";
export const GOT_SAMPLE_TYPES_LIST="GOT_SAMPLE_TYPES_LIST";

export const GOT_PROFILES_LIST = "GOT_PROFILES_LIST";
export const GET_FW_INFO_SUCCESS ="GET_SERVERINFO_SUCCESS";
export const GET_SERVERSTATUS_SUCCESS = "GET_SERVERSTATUS_SUCCESS";
export const ATTEMPT_DEVICE_RECONNECT = "ATTEMPT_DEVICE_RECONNECT";
export const GOT_LIGHT_UPDATE ="GOT_LIGHT_UPDATE";
export const GET_STATSINFO_SUCCESS = "GET_STATSINFO_SUCCESS";

export const SET_DEVICE_STATUS = "SET_DEVICE_STATUS";
export const SET_DEVICE_MODE = "SET_DEVICE_MODE";
export const SET_DEVICE_STATUS_AND_MODE = "SET_DEVICE_STATUS_AND_MODE";
export let GOT_CURRENT_REMOTE_USER_INFO = "GOT_CURRENT_REMOTE_USER_INFO";

